import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Clock, Linkedin, Instagram, Facebook, ArrowUpRight } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { resolveAssetUrl } from "@/lib/api";

export default function Footer() {
  const { content } = useSite();
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="bg-[#0a1128] text-slate-300 pt-20 pb-8 mt-0 relative overflow-hidden">
      <div className="absolute inset-0 tech-grid opacity-30 pointer-events-none"></div>
      <div className="glow-orb w-[400px] h-[400px] -top-32 -left-32 bg-dc-primary/30"></div>

      <div className="dc-container relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <Link to="/" className="inline-block mb-5">
              <img src={resolveAssetUrl(content?.logo_url_dark, "/brand/logo-dark.png")} alt="DeskcodeBR" className="h-12 w-auto" />
            </Link>
            <p className="text-sm leading-relaxed text-slate-400 mb-5">
              Soluções completas em tecnologia, infraestrutura e desenvolvimento de sistemas para empresas que exigem excelência.
            </p>
            <div className="flex gap-3">
              {content.linkedin && <a href={content.linkedin} target="_blank" rel="noreferrer" data-testid="footer-linkedin" className="w-9 h-9 rounded-full bg-white/5 hover:bg-dc-primary border border-white/10 flex items-center justify-center transition"><Linkedin className="w-4 h-4" /></a>}
              {content.instagram && <a href={content.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="w-9 h-9 rounded-full bg-white/5 hover:bg-dc-primary border border-white/10 flex items-center justify-center transition"><Instagram className="w-4 h-4" /></a>}
              {content.facebook && <a href={content.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook" className="w-9 h-9 rounded-full bg-white/5 hover:bg-dc-primary border border-white/10 flex items-center justify-center transition"><Facebook className="w-4 h-4" /></a>}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white text-sm uppercase tracking-widest mb-5">Navegação</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" className="hover:text-white transition flex items-center gap-1.5 group">Home <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition" /></Link></li>
              <li><Link to="/sobre" className="hover:text-white transition flex items-center gap-1.5 group">Sobre Nós <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition" /></Link></li>
              <li><Link to="/servicos" className="hover:text-white transition flex items-center gap-1.5 group">Serviços <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition" /></Link></li>
              <li><Link to="/orcamento" className="hover:text-white transition flex items-center gap-1.5 group">Orçamento <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition" /></Link></li>
              <li><Link to="/visita-tecnica" className="hover:text-white transition flex items-center gap-1.5 group">Visita Técnica <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition" /></Link></li>
              <li><Link to="/contato" className="hover:text-white transition flex items-center gap-1.5 group">Contato <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition" /></Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white text-sm uppercase tracking-widest mb-5">Contato</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3"><MapPin className="w-4 h-4 text-dc-accent mt-0.5 flex-shrink-0" /><span className="text-slate-400">{content.address}</span></li>
              <li className="flex items-start gap-3"><Phone className="w-4 h-4 text-dc-accent mt-0.5 flex-shrink-0" /><span className="text-slate-400">{content.phone}</span></li>
              <li className="flex items-start gap-3"><Mail className="w-4 h-4 text-dc-accent mt-0.5 flex-shrink-0" /><a href={`mailto:${content.email}`} className="text-slate-400 hover:text-white transition">{content.email}</a></li>
              <li className="flex items-start gap-3"><Clock className="w-4 h-4 text-dc-accent mt-0.5 flex-shrink-0" /><span className="text-slate-400">{content.hours}</span></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white text-sm uppercase tracking-widest mb-5">Vamos conversar</h4>
            <Link to="/orcamento" data-testid="footer-cta" className="inline-flex items-center gap-2 bg-gradient-to-r from-dc-primary to-dc-accent text-white px-5 py-3 rounded-full font-semibold text-sm hover:shadow-lg hover:shadow-dc-accent/20 transition-all">
              Solicitar orçamento <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-slate-500">
          <div>© {year} DeskcodeBR. Todos os direitos reservados.</div>
          <div className="flex items-center gap-6">
            <span>CNPJ: {content?.cnpj || "35.998.068/0001-96"}</span>
            <span>LGPD compliant</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
